module.exports = __webpack_public_path__ + "img/Pot1.72fa5af7.svg";